module.exports = __webpack_public_path__ + "static/img/jumper_mf-1.6777834.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_mf-1.svg
// module id = 0ot8
// module chunks = 0